import { numberFixed } from "./numberFixed"
import { spaceNumber } from "./spaceNumber"

export const numberSpaceFixer = (
  number: number | string | null = 0,
  fixed: number = 2
) => {
  if (!number) return 0

  if (typeof number === "string") return number

  return spaceNumber(numberFixed(number, fixed))
}
